import React from "react";
import { styles } from "./styles";
import { AdminGroupCardsView } from "./view";

export class AdminGroupCards extends React.Component {
  render() {
    return <AdminGroupCardsView {...this.props} styles={styles} />;
  }
}
